import React from 'react';
import { Helmet } from 'react-helmet';
import { ErrorFallback } from './errors/ErrorFallback';
import { useAuth } from './providers/AuthProvider';
import { Spinner } from 'ui/src/ui-components/spinner';

const AuthenticatedApp = React.lazy(
  () => import(/* webpackPrefetch: true */ './AuthenticatedApp')
);
const UnauthenticatedApp = React.lazy(() => import('./UnauthenticatedApp'));

const App = () => {
  const { storedJWT, fullUserIsLoading, backendDown } = useAuth();

  const render = () => {
    if (fullUserIsLoading) {
      return <Spinner fullPage />;
    }

    if (backendDown) {
      return <ErrorFallback />;
    }

    // TODO: Handle redirecting a user to a requested page if they come from a presigned link
    return storedJWT ? <AuthenticatedApp /> : <UnauthenticatedApp />;
  };

  return (
    <React.Suspense fallback={<Spinner fullPage />}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Whatis</title>
      </Helmet>
      {render()}
    </React.Suspense>
  );
};

export default App;
